import {
  AvailableDimension,
  AvailableFilter,
} from '../../campaigns/store/insightsTab/insightsTab.types';
import {DimensionValue} from '../analytics.types';
import _fromPairs from 'lodash/fromPairs';

export default function getRemoteDimensionKey<T>(
  availableOptions: AvailableDimension[] | AvailableFilter[],
  key: string | undefined,
) {
  if (!key) return null;

  const optionsMapping = _fromPairs(
    availableOptions.map((item) => [item.label, item.value]),
  ) as Record<string, DimensionValue>;

  return (optionsMapping[key] ??
    (Object.values(optionsMapping).includes(key as DimensionValue) ? key : null)) as T;
}
